import React, { useState, useEffect, useCallback } from 'react'
import { styled, SxProps } from '@mui/material/styles'
import { Stack, Divider, OutlinedInput } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { TreeDataProps } from './treeNode'
import { TreeView } from '@mui/x-tree-view'

export interface ListProps {
  data: unknown[]
  renderItem: (item: unknown, index: number, onItemClick?: (itemId: string) => void) => React.ReactElement
  header?: React.ReactElement
  searchKey: string
  sx?: SxProps
  treeView?: boolean
  treeData?: TreeDataProps[]
}

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}))

export const ScrollY = styled('div')(() => ({
  height: '100%',
  overflow: 'auto',
  ...(navigator?.userAgent?.indexOf('Chrome') != -1 && { overflow: 'overlay' }),
}))

const List: React.FC<ListProps> = (props) => {
  const { data, renderItem, treeView, treeData, searchKey, header, sx } = props
  const [keyword, setKeyword] = useState<string>('')
  const [expandedKeys, setExpandedKeys] = useState<string[]>([])
  // @ts-ignore
  const [filteredtreeData, setTreeData] = useState<TreeDataProps[]>(treeData)

  const dataFilter = () => {
    return (
      // @ts-ignore
      data?.filter((item) => item?.[searchKey]?.indexOf(keyword) > -1) ?? []
    )
  }

  const treeDataFilter = useCallback(() => {
    // @ts-ignore
    const filtered = [...treeData] as TreeDataProps[]
    const searchExpandedKeys: string[] = []
    if (keyword?.length > 0) {
      filtered.forEach((item) => {
        if (item.name?.indexOf(keyword) > -1 || item?.children?.find((child) => child?.name?.indexOf(keyword) > -1)) {
          searchExpandedKeys.push(item.id.toString())
        }
        if (item?.children) {
          item?.children?.forEach((child) => {
            if (child.name?.indexOf(keyword) > -1) {
              child.hightlight = true
            } else {
              child.hightlight = false
            }
          })
        }
      })
      setExpandedKeys(searchExpandedKeys)
      setTreeData(filtered)
    } else {
      // @ts-ignore
      setTreeData(treeData)
    }
  }, [keyword, treeData])

  const onTreeNodeClick = (nodeId: string) => {
    if (expandedKeys.indexOf(nodeId) > -1) {
      const expanded = expandedKeys.filter((expandedKey) => expandedKey !== nodeId)
      setExpandedKeys([...expanded])
    } else {
      setExpandedKeys([...expandedKeys, nodeId])
    }
  }

  useEffect(() => {
    // @ts-ignore
    if (treeData?.length > 0) {
      treeDataFilter()
    }
  }, [keyword, treeData, treeDataFilter])

  return (
    <Stack sx={{ padding: '16px', border: '1px solid #D9D9D9FF', ...sx }}>
      <OutlinedInput
        value={keyword}
        size='small'
        onChange={(e) => setKeyword(e.target.value)}
        placeholder='搜索'
        endAdornment={<SearchIcon />}
      />
      <Row sx={{ lineHeight: '40px', mt: 3 }}>{header}</Row>
      <ScrollY>
        <Stack
          sx={{
            flex: 1,
            height: '100%',
            overflow: 'auto',
          }}
        >
          {treeView ? (
            <TreeView expanded={expandedKeys}>
              {(keyword?.length > 0 ? filteredtreeData : treeData)?.map((item, index) =>
                renderItem(item, index, onTreeNodeClick),
              )}
            </TreeView>
          ) : (
            dataFilter()?.map((item, index) => renderItem(item, index))
          )}
        </Stack>
      </ScrollY>
    </Stack>
  )
}

export default List
